export enum ExternalProvider {
    Microsoft = 1,
    Google = 2,
}
